import type { AppType } from "@sytofood/api";
import { hc } from "hono/client";

import { env } from "./env";
import { captureSessionToken, fetchCredentials, nativeRequestHeaders } from "./native";

// On the web: HttpOnly sf_session cookie + credentials: "include" (unchanged).
// In the Capacitor WebView: the Domain=.sytofood.com cookie is cross-origin
// and rejected, so we omit it and carry the JWT as Authorization: Bearer.
// The first sign-in / sign-up / confirm-password-reset response carries
// X-Session-Token; captureSessionToken stores it in Capacitor Preferences
// for subsequent calls and restarts.
const sytofoodFetch: typeof fetch = async (input, init) => {
  const headers = new Headers(init?.headers);
  for (const [key, value] of Object.entries(nativeRequestHeaders())) {
    headers.set(key, value);
  }
  const response = await fetch(input, {
    ...init,
    credentials: fetchCredentials(),
    headers,
  });
  await captureSessionToken(response);
  return response;
};

export const apiClient = hc<AppType>(env.apiUrl, { fetch: sytofoodFetch });
export type ApiClient = typeof apiClient;
